import React from "react";
import { Notify } from "../../services/custom/Messages";
import { notification } from "antd";
import { FrownOutlined, SmileOutlined } from "@ant-design/icons";

export const openCaptureNotification = (title, description, type) => {

  const customNotificationStyle = {
    backgroundColor:
      type === Notify.ERROR
        ? "#d65944"
        : type === Notify.WARNING
          ? "#e58231"
          : "#6cbf43",
    border:
      type === Notify.ERROR
        ? "2px solid #a82e1a"
        : type === Notify.WARNING
          ? "2px solid #934c14"
          : "2px solid #3d7720",
    color: "#FFFFFF",
    fontWeight: "bold",
  };

  notification[type]({
    message: title,
    description,
    placement: "top",
    duration: 2,
    style: {
      marginLeft: "auto",
      marginRight: "auto",
      width: 320,
      textAlign: "center",
    },
    style: customNotificationStyle,
    icon: type === Notify.ERROR ? <FrownOutlined /> : <SmileOutlined />
  });
};
